// input components size for: common/mixins/addressFormMixin.js
const INPUT_SIZE = 'lg';
const INPUT_LABEL_PLACE_OUTER = false;

// eslint-disable-next-line no-undef
export default defineAppConfig({
  INPUT_SIZE,
  INPUT_LABEL_PLACE_OUTER,
});
